import React, { useState, useRef, useEffect } from "react";
import "./CountryCodeSelector.scss";
import { itx } from "../../../translationItx/itx";

export interface Country {
  code: string;
  name: string;
  flagUrl: string;
  dialCode: string;
}

const COUNTRIES: Country[] = [
  {
    code: "DE", // no itx
    name: itx("CountryCodeSelector.germany", "Deutschland"),
    flagUrl: "https://flagcdn.com/de.svg", // no itx
    dialCode: "+49", // no itx
  },
  {
    code: "AT", // no itx
    name: itx("CountryCodeSelector.austria", "Österreich"),
    flagUrl: "https://flagcdn.com/at.svg", // no itx
    dialCode: "+43", // no itx
  },
  {
    code: "CH", // no itx
    name: itx("CountryCodeSelector.switzerland", "Schweiz"),
    flagUrl: "https://flagcdn.com/ch.svg", // no itx
    dialCode: "+41", // no itx
  },
  {
    code: "BE", // no itx
    name: itx("CountryCodeSelector.belgium", "Belgien"),
    flagUrl: "https://flagcdn.com/be.svg", // no itx
    dialCode: "+32", // no itx
  },
  {
    code: "NL", // no itx
    name: itx("CountryCodeSelector.netherlands", "Niederlande"),
    flagUrl: "https://flagcdn.com/nl.svg", // no itx
    dialCode: "+31", // no itx
  },
  {
    code: "FR", // no itx
    name: itx("CountryCodeSelector.france", "Frankreich"),
    flagUrl: "https://flagcdn.com/fr.svg", // no itx
    dialCode: "+33", // no itx
  },
  {
    code: "IT", // no itx
    name: itx("CountryCodeSelector.italy", "Italien"),
    flagUrl: "https://flagcdn.com/it.svg", // no itx
    dialCode: "+39", // no itx
  },
  {
    code: "ES", // no itx
    name: itx("CountryCodeSelector.spain", "Spanien"),
    flagUrl: "https://flagcdn.com/es.svg", // no itx
    dialCode: "+34", // no itx
  },
  {
    code: "GB", // no itx
    name: itx("CountryCodeSelector.unitedKingdom", "Großbritannien"),
    flagUrl: "https://flagcdn.com/gb.svg", // no itx
    dialCode: "+44", // no itx
  },
  {
    code: "IE", // no itx
    name: itx("CountryCodeSelector.ireland", "Irland"),
    flagUrl: "https://flagcdn.com/ie.svg", // no itx
    dialCode: "+353", // no itx
  },
  {
    code: "PT", // no itx
    name: itx("CountryCodeSelector.portugal", "Portugal"),
    flagUrl: "https://flagcdn.com/pt.svg", // no itx
    dialCode: "+351", // no itx
  },
  {
    code: "SE", // no itx
    name: itx("CountryCodeSelector.sweden", "Schweden"),
    flagUrl: "https://flagcdn.com/se.svg", // no itx
    dialCode: "+46", // no itx
  },
  {
    code: "NO", // no itx
    name: itx("CountryCodeSelector.norway", "Norwegen"),
    flagUrl: "https://flagcdn.com/no.svg", // no itx
    dialCode: "+47", // no itx
  },
  {
    code: "DK", // no itx
    name: itx("CountryCodeSelector.denmark", "Dänemark"),
    flagUrl: "https://flagcdn.com/dk.svg", // no itx
    dialCode: "+45", // no itx
  },
  {
    code: "FI", // no itx
    name: itx("CountryCodeSelector.finland", "Finnland"),
    flagUrl: "https://flagcdn.com/fi.svg", // no itx
    dialCode: "+358", // no itx
  },
  {
    code: "PL", // no itx
    name: itx("CountryCodeSelector.poland", "Polen"),
    flagUrl: "https://flagcdn.com/pl.svg", // no itx
    dialCode: "+48", // no itx
  },
  {
    code: "CZ", // no itx
    name: itx("CountryCodeSelector.czechRepublic", "Tschechien"),
    flagUrl: "https://flagcdn.com/cz.svg", // no itx
    dialCode: "+420", // no itx
  },
  {
    code: "SK", // no itx
    name: itx("CountryCodeSelector.slovakia", "Slowakei"),
    flagUrl: "https://flagcdn.com/sk.svg", // no itx
    dialCode: "+421", // no itx
  },
  {
    code: "HU", // no itx
    name: itx("CountryCodeSelector.hungary", "Ungarn"),
    flagUrl: "https://flagcdn.com/hu.svg", // no itx
    dialCode: "+36", // no itx
  },
  {
    code: "RO", // no itx
    name: itx("CountryCodeSelector.romania", "Rumänien"),
    flagUrl: "https://flagcdn.com/ro.svg", // no itx
    dialCode: "+40", // no itx
  },
  {
    code: "BG", // no itx
    name: itx("CountryCodeSelector.bulgaria", "Bulgarien"),
    flagUrl: "https://flagcdn.com/bg.svg", // no itx
    dialCode: "+359", // no itx
  },
  {
    code: "GR", // no itx
    name: itx("CountryCodeSelector.greece", "Griechenland"),
    flagUrl: "https://flagcdn.com/gr.svg", // no itx
    dialCode: "+30", // no itx
  },
  {
    code: "US", // no itx
    name: itx("CountryCodeSelector.unitedStates", "USA"),
    flagUrl: "https://flagcdn.com/us.svg", // no itx
    dialCode: "+1", // no itx
  },
  {
    code: "CA", // no itx
    name: itx("CountryCodeSelector.canada", "Kanada"),
    flagUrl: "https://flagcdn.com/ca.svg", // no itx
    dialCode: "+1", // no itx
  },
  {
    code: "AU", // no itx
    name: itx("CountryCodeSelector.australia", "Australien"),
    flagUrl: "https://flagcdn.com/au.svg", // no itx
    dialCode: "+61", // no itx
  },
  {
    code: "JP", // no itx
    name: itx("CountryCodeSelector.japan", "Japan"),
    flagUrl: "https://flagcdn.com/jp.svg", // no itx
    dialCode: "+81", // no itx
  },
  {
    code: "CN", // no itx
    name: itx("CountryCodeSelector.china", "China"),
    flagUrl: "https://flagcdn.com/cn.svg", // no itx
    dialCode: "+86", // no itx
  },
  {
    code: "IN", // no itx
    name: itx("CountryCodeSelector.india", "Indien"),
    flagUrl: "https://flagcdn.com/in.svg", // no itx
    dialCode: "+91", // no itx
  },
  {
    code: "BR", // no itx
    name: itx("CountryCodeSelector.brazil", "Brasilien"),
    flagUrl: "https://flagcdn.com/br.svg", // no itx
    dialCode: "+55", // no itx
  },
  {
    code: "MX", // no itx
    name: itx("CountryCodeSelector.mexico", "Mexiko"),
    flagUrl: "https://flagcdn.com/mx.svg", // no itx
    dialCode: "+52", // no itx
  },
];

interface CountryCodeSelectorProps {
  value: string;
  onChange: (dialCode: string, countryCode: string) => void;
  disabled?: boolean;
}

export const CountryCodeSelector: React.FC<CountryCodeSelectorProps> = ({ value, onChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country>(
    COUNTRIES.find((c) => c.dialCode === value) || COUNTRIES[0],
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const country = COUNTRIES.find((c) => c.dialCode === value);
    if (country) {
      setSelectedCountry(country);
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCountrySelect = (country: Country) => {
    setSelectedCountry(country);
    onChange(country.dialCode, country.code);
    setIsOpen(false);
  };

  return (
    <div className="country-code-selector" ref={dropdownRef}>
      <button type="button" className="country-code-button" onClick={() => setIsOpen(!isOpen)} disabled={disabled}>
        <img src={selectedCountry.flagUrl} alt={selectedCountry.code} className="country-flag" />
        <span className="country-code">{selectedCountry.code}</span>
        <span className="dropdown-arrow">▼</span>
      </button>

      {isOpen && (
        <div className="country-code-dropdown">
          <ul className="country-code-list">
            {COUNTRIES.map((country) => (
              <li
                key={country.code}
                className={`country-code-item ${selectedCountry.code === country.code ? "active" : ""}`}
                onClick={() => handleCountrySelect(country)}
              >
                <img src={country.flagUrl} alt={country.code} className="country-flag" />
                <span className="country-code">{country.code}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
